import Vue from 'vue';
import { sync } from 'vuex-router-sync';

import App from './page/App.vue';
import { createRouter } from './router';
import { createStore } from './store';

export function createApp(config) {
  const store = createStore(config);
  const router = createRouter();

  sync(store, router);

  const app = new Vue({
    router,
    store,
    render: h => h(App),
  });

  return { app, router, store };
}
